import listReducer from '../common/list-reducer';
import pagingReducer from '../common/paging-reducer';

import {getCustomersAction} from "./actions";

const customersReducer = listReducer.bind(getCustomersAction.getListReduceThisObj());
const customersPagingReducer = pagingReducer.bind(getCustomersAction.getPagingReducerThisObj());

export default ({
    customers: customersReducer,
    customersPaging: customersPagingReducer
});